import { inject, Injectable } from '@angular/core';

import {
  OutputEmitGuard,
  PerformChecksConfig,
} from '../../canvas-elements/io-data/models/output-handler.models';
import { FormCommitButtonRegistry } from '../../services/forms/runtime/public-api';

@Injectable({ providedIn: 'root' })
export class TextInputOutputEmitGuard implements OutputEmitGuard {
  private readonly commitButtons = inject(FormCommitButtonRegistry);

  preEmit({ event }: PerformChecksConfig): boolean {
    if (event.eventType === 'submit') {
      this.commitButtons.submit(event.data as string);
      return false;
    }
    return true;
  }
}
